import { Grid } from '@material-ui/core';
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getInActiveIdeaList, getMyIdeaList } from 'screens/Ideation/actions';
import useDidMountEffect from 'utilize/Hook/useDidMountEffect';
import InfiniteScrollComponent from './infiniteScroll';

export default function InfiniteScrollMyIdea({ filterIdea, tab }) {
	const dispatch = useDispatch();

	const myIdeas = useSelector((state) => state?.ideation?.myIdeas);
	const myReservedIdeas = useSelector((state) => state?.ideation?.myReservedIdeas);

	const fetchData = () => {
		if (filterIdea) {
			dispatch(getMyIdeaList(filterIdea));
		}
	};
	
	return (
		<Grid container>
			<InfiniteScrollComponent
				data={tab === 1 ? myIdeas : myReservedIdeas}
				hasMore={false}
				fetchData={fetchData}
				section="search"
			/>
		</Grid>
	);
}
